/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
// @ts-nocheck
import React, { useState, useEffect } from 'react'
import { useAccount } from 'wagmi'
import { getChainId, readContract } from '@wagmi/core'
import TopBar from '../components/TopBar.jsx'
import CustomRadioButton from '../components/CustomRadioButton.jsx'
import ClipLoader from 'react-spinners/ClipLoader'
import { StringParam, useQueryParam } from 'use-query-params'
import TradeCard from '../components/TradeCard.jsx'
import BalanceCard from '../components/BalanceCard.jsx'
import LaunchpadCard from '../components/LaunchpadCard.jsx'
import { imageUrl, apiUrl, ethPriceApiUrl, supportedChainIds, chainLogos, scanLinks, coinNames, projectName } from '../utils/constants.ts'
import { getMulticallAddress } from '../utils/addressHelpers.ts'
import rot13 from '../utils/encode.ts'
import { BASE_URL } from '../utils/constants.ts'
import CopyIcon from '../icons/copy.svg'
import { config } from '../config'
import MultiCallAbi from '../config/MultiCallAbi.json'
import PumpFunAbi from '../config/PumpFunAbi.json'
import { writeContract, waitForTransaction } from '@wagmi/core'
import toast from 'react-hot-toast'
import Footer from '../components/Footer';

const Profile = () => {
  let [profileAddress] = useQueryParam('address', StringParam)
  const { address } = useAccount()
  if (profileAddress === "undefined")
    profileAddress = address;
  let [loading, setLoading] = useState(false)
  const [fetched, setFetched] = useState(false)
  const [fetched1, setFetched1] = useState(false)

  const [selectedOption, setSelectedOption] = useState('Trades')
  const handleSelect = value => setSelectedOption(value)
  const [, setTotalLength] = useState(0)
  const [funLists, setFunListData] = useState([])
  const [funBalances, setFunBalances] = useState([])
  const [history, setHistory] = useState([{ amount: 0, name: '', token: '', type: '', date: '' }])
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false)
  const [claimingAddress, setClaimingAddress] = useState(null) // Track which token is being claimed

  useEffect(() => {
    const FetchBalances = async () => {
      if (!profileAddress) {
        console.warn('Profile address not available, skipping balance fetch')
        setLoading(false)
        setFetched1(true)
        return
      }

      try {
        setLoading(true)
        setFunBalances([]) // Clear previous balances
        
        console.log('Fetching balances for address:', profileAddress)
        
        for (const chainId of supportedChainIds) {
          try {
            console.log(`Fetching getUserBalance for chain ${chainId}...`)
            let mainInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getUserBalance',
              args: [profileAddress],
              chainId: chainId
            })
            
            console.log(`getUserBalance response for chain ${chainId}:`, mainInfo)

            if (mainInfo && Array.isArray(mainInfo) && mainInfo.length >= 4) {
              const names = mainInfo[0]
              const symbols = mainInfo[1]
              const addresses = mainInfo[2]
              const balances = mainInfo[3]
              
              if (names && Array.isArray(names) && names.length > 0) {
                setTotalLength(names.length)
                for (let i = names.length - 1; i >= 0; i--) {
                  const name = names[i]
                  const symbol = symbols[i]
                  const contractAddress = addresses[i]
                  const balance = Number(balances[i]) / (10 ** 18)
                  let logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png'
                  const funData = {
                    chainId,
                    name: name,
                    symbol: symbol,
                    contractAddress: contractAddress,
                    logoUrl: logoUrl,
                    balance: balance
                  }
                  setFunBalances(prev => [...prev, funData])
                }
                console.log(`Added ${names.length} balances for chain ${chainId}`)
              } else {
                console.log(`No balances found for chain ${chainId}`)
              }
            } else {
              console.log(`Invalid response structure for chain ${chainId}:`, mainInfo)
            }
          } catch (chainError) {
            console.error(`Error fetching balance for chain ${chainId}:`, chainError)
            // Continue with other chains even if one fails
          }
        }
        setLoading(false)
        setFetched1(true)
        console.log('Finished fetching balances. Total balances:', funBalances.length)
      } catch (e) {
        setLoading(false)
        setFetched1(true)
        console.error('Error in FetchBalances:', e)
      }
    }

    const FetchTrades = async () => {
      try {
        await fetch(
          apiUrl + `/getUserHistory/${profileAddress}`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json()
          if (data.length > 0) {
            let history = {}
            let historyData: any[] = []
            for (let i = 0; i < data?.length; i++) {
              let chainId = data[i].chainId
              let amount = data[i].amount
              let buyer = data[i].buyer
              let name = data[i].name
              let token = data[i].token
              let type = data[i].type
              let contract = data[i].contract
              let currentDate = Date.now()
              let timestamp = currentDate / 1000 - Number(data[i].timestamp)
              let date
              if (timestamp > 86400) {
                date = (timestamp / 86400).toFixed(0) + ' days ago'
              } else if (timestamp > 3600) {
                date = (timestamp / 3600).toFixed(0) + ' hours ago'
              } else if (timestamp > 0) {
                date = (timestamp / 60).toFixed(0) + ' mins ago'
              } else {
                date = ' just now'
              }
              history = { chainId, amount: amount, buyer: buyer, name: name, token: token, type: type, contract: contract, date: date }
              historyData.push(history)
            }
            setHistory(historyData.slice().reverse())
          } else {
            setHistory([{ amount: 0, name: '', token: '', type: '', date: '' }])
          }
        })
      } catch (e) {
        console.error(e)
      }
    }

     const FetchDeployedData = async () => {
      if (!profileAddress) {
        console.warn('Profile address not available, skipping deployed data fetch')
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        setFunListData([]) // Clear previous data

        for (const chainId of supportedChainIds) {
          try {
            const ethPriceResponse = await fetch(ethPriceApiUrl[chainId], { method: 'GET' });
            const ethPriceData = await ethPriceResponse.json();
            const ethPrice = ethPriceData.USD;

            let mainInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getUserDeployMainInfo',
              args: [profileAddress],
              chainId: chainId
            })
            let otherInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getUserDeployOtherInfo',
              args: [profileAddress],
              chainId: chainId
            })
            const globalOtherInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getOtherInfo',
              chainId: chainId,
            });
            const restInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getRestInfo',
              chainId: chainId
            })

            let tokenInfo = await readContract(config, {
              address: getMulticallAddress(chainId),
              abi: MultiCallAbi,
              functionName: 'getUserBalance',
              args: [profileAddress],
              chainId: chainId
            })
            
          
            if (mainInfo && otherInfo && tokenInfo && tokenInfo[2] && Array.isArray(tokenInfo[2])) {
              setTotalLength(mainInfo[0].length)
              if (mainInfo[0].length > 0) {
                for (let i = mainInfo[0].length - 1; i >= 0; i--) {
                  const contractAddress = mainInfo[4][i]
                  const tokenAddress = tokenInfo[2][i]
                  const lpCreated = restInfo[1][i];
                const virtualLpAmounts = Number(mainInfo[1][i]) * ethPrice
                const tokenPrice = Number(mainInfo[2][i])
                const marketCap = (tokenPrice * 1000000000 * Number(ethPrice)) / 10 ** 12
                const price = (tokenPrice * Number(ethPrice)) / 10 ** 12
                const startTime = mainInfo[0] && mainInfo[0][i] != null ? Number(mainInfo[0][i]) : undefined
                const website = otherInfo[2][i]
                const twitter = otherInfo[3][i]
                const telegram = otherInfo[4][i]
                let raisingPercent = Number(globalOtherInfo[5][i]) / 100;
                let progress = lpCreated ? 100 : (raisingPercent > 0 ? (marketCap * 100) / 116000 : 0);
                const liquidity = virtualLpAmounts
                const name = otherInfo[0][i]
                const symbol = otherInfo[1][i]
                // Use tokenName format first (for privacy wallet), LaunchpadCard will fallback to projectName format
                let logoUrl = imageUrl + 'logo/' + name + "-" + chainId + "-" + contractAddress + '.png'
                let bannerUrl = imageUrl + 'banner/' + name + "-" + chainId + "-" + contractAddress + '.png'
                let blockchainLogoUrl = chainLogos[chainId]
                let devAddress = mainInfo[5][i]
                let dexAddress = 'https://app.uniswap/swap'
                let dexName = 'Uniswap'
                const description = restInfo[2][i]
                // accumulatedCreatorReward from multicall (mainInfo[6] = uint256[] per deploy), in native token wei
                const accumulatedCreatorRewardWei = mainInfo[6]?.[i] != null ? Number(mainInfo[6][i]) : 0
                const accumulatedCreatorReward = accumulatedCreatorRewardWei / 10 ** 18
                const funData = {
                  chainId: chainId,
                  progress: progress,
                  Liquidity: liquidity,
                  tokenName: name,
                  tokenSymbol: symbol,
                  tokenDescription: description,
                  logoUrl: logoUrl,
                  bannerUrl: bannerUrl,
                  address: mainInfo[4][i],
                  depositedAmount: Number(mainInfo[3][i]) * ethPrice / 10 ** 18,
                  contractAddress: contractAddress,
                  tokenAddress: tokenAddress,
                  dexAddress: dexAddress,
                  devAddress: devAddress,
                  dexName: dexName,
                  marketCap: marketCap,
                  price,
                  startTime,
                  website: website,
                  twitter: twitter,
                  telegram: telegram,
                  blockchainLogoUrl: blockchainLogoUrl,
                  funAddress: contractAddress,
                  accumulatedCreatorReward,
                  nativeSymbol: coinNames[chainId] || 'ETH'
                }
                setFunListData(prevState => [...prevState, funData])
                }
              }
            }
          } catch (chainError) {
            console.error(`Error fetching deployed data for chain ${chainId}:`, chainError)
            // Continue with other chains even if one fails
          }
        }
        setLoading(false)
        setFetched(true)
      } catch (e) {
        setLoading(false)
        console.error('Error in FetchDeployedData:', e)
      }
    }

    if (profileAddress) {
      if (selectedOption === 'Deploys' && !fetched) {
        FetchDeployedData()
      } else if (selectedOption === 'Balances' && !fetched1) {
        FetchBalances()
      } else if (selectedOption === 'Trades') {
        FetchTrades()
      }
    }
  }, [selectedOption, profileAddress])

  // Handle creator claim
  const handleClaim = async (funAddress, chainId) => {
    if (!address) {
      toast.error('Please connect your wallet')
      return
    }

    if (claimingAddress) {
      return // Already claiming
    }

    try {
      setClaimingAddress(funAddress)
      toast.loading('Claiming creator rewards...', { id: 'claim' })

      const tx = await writeContract(config, {
        address: funAddress as `0x${string}`,
        abi: PumpFunAbi,
        functionName: 'creatorclaim',
        chainId: Number(chainId)
      })

      await waitForTransaction(config, {
        hash: tx,
        chainId: Number(chainId)
      })

      toast.success('Creator rewards claimed successfully!', { id: 'claim' })
      setClaimingAddress(null)
    } catch (error) {
      console.error('Claim error:', error)
      setClaimingAddress(null)
      
      if (error.message?.includes('user rejected') || error.message?.includes('User rejected')) {
        toast.error('Transaction rejected by user', { id: 'claim' })
      } else if (error.message?.includes('revert') || error.message?.includes('reverted')) {
        toast.error('Claim failed: No rewards available or already claimed', { id: 'claim' })
      } else {
        toast.error(error.message || 'Failed to claim creator rewards', { id: 'claim' })
      }
    }
  }



  const referlink = address ? `${BASE_URL}/?ref=${rot13(address)}` : `${BASE_URL}/?ref=`

  const copyAddress = address => async e => {
    e.stopPropagation()
    e.preventDefault()
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = address
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      toast.success('Copied to clipboard')
      // displayTooltip()
    }
  }

  function displayTooltip() {
    let timeoutId
    setIsTooltipDisplayed(true)
    timeoutId = setTimeout(() => {
      setIsTooltipDisplayed(false)
    }, 1000)
    return () => clearTimeout(timeoutId)
  }

  const [currentTransactionPage, setCurrentTransactionPage] = useState(1)
  const [transactionTotalPages, setTransactionTotalPages] = useState(0)
  const transactionItemsPerPage = 25
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([])
  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = []

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages]
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ]
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1]
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages]
        }
      }
    }

    return pages
  }

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    )
  }

  useEffect(() => {
    const totalPages = Math.ceil(
      history.length / transactionItemsPerPage
    )
    setTransactionTotalPages(totalPages)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    )
  }, [history])
  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <div className="flex-grow">
        <TopBar />
        <div className='max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6'>
          <div className='flex flex-col md:flex-row gap-6'>
            <section
              className="w-full p-6 rounded-xl"
              style={{
                background: 'var(--card-bg)',
                border: '2px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}
            >
              <div className="flex flex-wrap gap-4 mb-6">
                {/* <CustomRadioButton
                  value="Balances"
                  selectedValue={selectedOption}
                  handleSelect={handleSelect}
                /> */}
                <CustomRadioButton
                  value="Trades"
                  selectedValue={selectedOption}
                  handleSelect={handleSelect}
                />
                <CustomRadioButton
                  value="Deploys"
                  selectedValue={selectedOption}
                  handleSelect={handleSelect}
                />
              </div>

              {/* {selectedOption === 'Balances' && (
                <>
                  {funBalances.length > 0 ? (
                    <>
                      {!loading && funBalances.map(({ chainId, name, symbol, contractAddress, logoUrl, balance }, i) => (
                        <div key={i} className="mb-4">
                          <BalanceCard
                            chainId={chainId}
                            chainLogo={chainLogos[chainId]}
                            name={name}
                            symbol={symbol}
                            contractAddress={contractAddress}
                            logoUrl={logoUrl}
                            balance={balance}
                          />
                        </div>
                      ))}
                      {loading && (
                        <div className="flex flex-col gap-4 items-center py-8">
                          <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                            Loading...
                          </p>
                          <ClipLoader
                            color='var(--text-accent)'
                            loading={true}
                            size={50}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className='text-center py-8' style={{ color: 'var(--text-secondary)' }}>
                      No Data
                    </div>
                  )}
                </>
              )} */}

              {selectedOption === 'Trades' && (
                <>
                  <div className='overflow-x-auto'>
                    <div className="grid grid-cols-4 gap-4 p-3 mb-4" style={{
                      background: 'var(--section-bg)',
                      borderRadius: '8px',
                      minWidth: '600px'
                    }}>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Token</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Type</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Amount</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Date</div>
                    </div>
                  </div>

                  {history[0].name !== '' ? (
                    history.slice(
                      (currentTransactionPage - 1) * transactionItemsPerPage,
                      currentTransactionPage * transactionItemsPerPage
                    ).map(({ chainId, amount, name, token, type, date }, i) => (
                      <TradeCard
                        key={i}
                        name={name}
                        amount={amount}
                        token={token}
                        type={type}
                        date={date}
                        scanLink={scanLinks[chainId]}
                        coinName={coinNames[chainId]}
                      />
                    ))
                  ) : (
                    <div className='py-4 text-center' style={{ color: 'var(--text-secondary)' }}>
                      No Data
                    </div>
                  )}

                  <div className="flex justify-center mt-8">
                    <div className="flex gap-1">
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(1)}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &lt;&lt;
                      </button>
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(Math.max(currentTransactionPage - 1, 1))}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &lt;
                      </button>
                      {transactionPageNumbers.map((pageNumber, index) => (
                        <button
                          key={index}
                          className={`px-3 py-1 rounded-lg ${currentTransactionPage === pageNumber
                            ? 'bg-gradient-to-r from-blue-500 to-cyan-500'
                            : 'bg-transparent'}`}
                          onClick={() => typeof pageNumber === 'number' && handleTransactionPageChange(pageNumber)}
                          style={{
                            border: '1px solid var(--input-border)',
                            color: typeof pageNumber === 'number'
                              ? currentTransactionPage === pageNumber
                                ? '#000000'
                                : 'var(--text-primary)'
                              : 'var(--text-secondary)',
                            background: typeof pageNumber === 'number' && currentTransactionPage === pageNumber
                              ? 'var(--primary-gradient)'
                              : 'var(--card-bg)'
                          }}
                        >
                          {pageNumber}
                        </button>
                      ))}
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(Math.min(currentTransactionPage + 1, transactionTotalPages))}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &gt;
                      </button>
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(transactionTotalPages)}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &gt;&gt;
                      </button>
                    </div>
                  </div>
                </>
              )}

              {selectedOption === 'Deploys' && (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {!loading && funLists.length > 0 && [...funLists].reverse().map((item, i) => (
                      item.tokenName !== '' && (
                        <LaunchpadCard 
                          key={item.funAddress ?? i} 
                          {...item}
                          hideTopBanner
                        />
                      )
                    ))}
                  </div>
                  {!loading && funLists.length === 0 && (
                    <div className='text-center py-8' style={{ color: 'var(--text-secondary)' }}>
                      No Data
                    </div>
                  )}
                  {loading && (
                    <div className="flex flex-col gap-4 items-center py-8">
                      <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                        Loading...
                      </p>
                      <ClipLoader
                        color='var(--text-accent)'
                        loading={true}
                        size={50}
                      />
                    </div>
                  )}
                </>
              )}
            </section>

            {/* Referral Card - Hidden for Deploys */}
            {/* {selectedOption !== 'Deploys' && (
              <div className="w-full md:w-96 h-fit p-6 rounded-xl" style={{
                background: 'var(--card-bg)',
                border: '2px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}>
                <div className="text-center mb-6">
                  <h3 className='text-2xl font-bold mb-2' style={{ color: 'var(--text-primary)' }}>
                    Earn <span style={{ color: 'var(--text-accent)' }}>0.5%</span> of each trade
                  </h3>
                  <p className="text-md" style={{ color: 'var(--text-secondary)' }}>
                    Share referral link with your friends and earn 0.5% of every trade they make.
                  </p>
                </div>
                <div className='flex gap-2'>
                  <div className='flex-1 p-3 rounded-lg truncate' style={{
                    background: 'var(--input-bg)',
                    border: '1px solid var(--input-border)',
                    color: isTooltipDisplayed ? 'var(--text-accent)' : 'var(--text-primary)'
                  }}>
                    {isTooltipDisplayed ? "Copied!" : referlink}
                  </div>
                  <button
                    className='p-3 rounded-lg flex items-center justify-center transition-colors'
                    onClick={copyAddress(referlink)}
                    style={{
                      background: 'var(--button-secondary-bg)',
                      border: '2px solid var(--button-secondary-border)',
                      color: 'var(--button-secondary-text)',
                      minWidth: '44px'
                    }}
                  >
                    <ClipboardIcon />
                  </button>
                </div>
              </div>
            )} */}
          </div>

          {/* Commented Out Section (updated but kept commented) */}
          {/*
          <div className="grid xl:grid-cols-1 gap-4 mt-8">
            <div className="flex flex-col gap-3">
              <div
                className="flex flex-col-reverse lg:flex-row rounded-[40px] p-8 items-center justify-around"
                style={{
                  background: 'var(--primary-gradient)',
                  boxShadow: '0 5px 10px rgba(0,0,0,0.2)',
                  border: '2px solid var(--border-color)',
                }}
              >
                <div className="text-center max-w-2xl">
                  <div className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
                    Refer HOTKEY to your friends and start earning
                  </div>
                  <div className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                    Introduce your friends to a better way to trade. Refer them to Blackoump.fun, and you will get{' '}
                    <span className="font-bold" style={{ color: 'var(--text-accent)' }}>
                      50% of the fees
                    </span>
                  </div>
                </div>
                <div>
                  <img style={{ height: '180px' }} src={footericon} alt="Referral" />
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Profile

const ClipboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="20"
    height="20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-2m-2-2h-4m0 0h4m-4 0v2h4V3m-4 6h4"
    />
  </svg>
);